import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Badge, Button, Card, Spinner } from 'react-bootstrap';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'react-toastify';
import PageLayout from '../../layouts/PageLayout';
import { employeeAPI } from '../../services';
import EmployeePointHistoryTab from '../../components/tables/EmployeePointHistoryTab';

export default function EmployeeTltHistoryPage() {
  const { employeeId } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!employeeId) return;
    (async () => {
      try {
        setLoading(true);
        setNotFound(false);
        const res = await employeeAPI.getEmployeeById(employeeId);
        setEmployee(res?.data ?? res ?? null);
      } catch (e) {
        console.error(e);
        toast.error('Không tải được thông tin nhân viên');
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [employeeId]);

  return (
    <PageLayout>
      <div className="mc-page">
        <div className="mc-page-header my-2 d-flex align-items-center gap-2 flex-wrap">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => navigate('/employees')}
          >
            <ArrowLeft size={18} className="me-1" />
            Quay lại
          </Button>
          <h1 className="mb-0">Lịch sử điểm TLT</h1>
          {employee && <Badge bg="primary">{employee.full_name || employee.username}</Badge>}
        </div>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" />
          </div>
        ) : notFound ? (
          <p className="text-muted text-center py-5 mb-0">Không tìm thấy nhân viên.</p>
        ) : (
          <Card>
            <Card.Body>
              <EmployeePointHistoryTab employeeId={employeeId} />
            </Card.Body>
          </Card>
        )}
      </div>
    </PageLayout>
  );
}
